/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconLane = createReactComponent("lane", "IconLane", [
  ["path", { d: "M4 6v13", key: "svg-0" }],
  ["path", { d: "M20 6v13", key: "svg-1" }]
]);

export { IconLane as default };
//# sourceMappingURL=IconLane.js.map
